import { CustomComponentProps } from "utils/types/generalTypes";
import NotificationsDropdown from "../dropdowns/navdropdowns/NotificationsDropdown";
import MessagesDropdown from "../dropdowns/navdropdowns/MessagesDropdown";
import AccountDropdown from "../dropdowns/navdropdowns/AccountDropdown";
import useWindowSize from "utils/hooks/useWindowSize";
import { logo } from "utils/assets_exports/images";
import { Link } from "react-router-dom";

export type TopNavProps = CustomComponentProps & {
    title: string;
    activeClass: "active" | "";
    toggle: Function;
};

const TopNav = ({ activeClass, toggle, className, style }: TopNavProps) => {
    const [windowWidth] = useWindowSize();
    return (
        <div
            className={`toolbar-v1 is-narrow d-flex flex-j-between flex-a-center gap-5 ${className}`}
            style={style}
        >
            {windowWidth < 992 ? (
                <div className="friendkit-hamburger sidebar-v1-trigger">
                    <span className="menu-toggle has-chevron">
                        <span
                            className={`icon-box-toggle ${activeClass}`}
                            onClick={() => toggle()}
                        >
                            <span className="rotate">
                                <i className="icon-line-top"></i>
                                <i className="icon-line-center"></i>
                                <i className="icon-line-bottom"></i>
                            </span>
                        </span>
                    </span>
                </div>
            ) : (
                <div style={{ width: "162px", marginRight: "auto" }}></div>
            )}
            {/* <h1>{title}</h1> */}
            <Link to="/">
                <img
                    src={logo}
                    alt="Momeento logo"
                    style={{ width: "40px", height: "40px" }}
                />
            </Link>

            <div className="controls">
                <NotificationsDropdown />
                <MessagesDropdown />
                <AccountDropdown />
            </div>
        </div>
    );
};

export default TopNav;
